/**
 * The business date with no signal.
 *
 * The server owns the calendar (CLAUDE.md, "Money, time, identity"), and while
 * the tablet can reach it, `today` always comes from `/me`. With no signal
 * there is nothing to ask, and the alternative to the device clock is a date
 * cached from the last connection — which is wrong by construction the moment
 * midnight passes. A tablet's clock is set from the network and is right to
 * the minute; a cached date is stale by the morning.
 *
 * So, offline only: the device clock read in Asia/Colombo. The Worker checks
 * every date on sync and refuses one in the future, so the worst a wrong clock
 * can do is queue a day that is then reported as a problem.
 */

const TIMEZONE = 'Asia/Colombo';

export function businessDateNow(now: Date = new Date()): string {
  // en-CA formats as YYYY-MM-DD.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

export function isSundayDate(date: string): boolean {
  return new Date(`${date}T00:00:00Z`).getUTCDay() === 0;
}

/** The Saturday ending the pay week that holds this date. */
export function payWeekEndingOf(date: string): string {
  const day = new Date(`${date}T00:00:00Z`);
  const toSaturday = (6 - day.getUTCDay() + 7) % 7;
  return new Date(day.getTime() + toSaturday * 86_400_000).toISOString().slice(0, 10);
}
